module.exports = __webpack_public_path__ + "img/ctt830-icon.8fd41a5b.png";